"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Program = void 0;
const Adafruit_NeoPixel_1 = require("../../System/ArduinoLibraryClones/Adafruit_NeoPixel");
const mqtt_connection_1 = require("../../System/ArduinoLibraryClones/mqtt_connection");
const ArduinoGlobals_1 = require("../../System/Simulator/ArduinoGlobals");
const message_processor_1 = require("./message_processor");
const snake_lights_1 = require("./snake_lights");
const DataStructures_1 = require("./DataStructures");
const networking_1 = require("./networking");
const PIN = 4;
let interval = 10;
const cfg = {
    wifi: { ssid: "ssid", password: "password" },
    mqtt: { server: "mqtt.ably.io", port: 8883, user: "api_key_part1", password: "api_key_part2", certificate: "cd bd 99 20 90 9d 5f 69 e5 76 6a b0 d1 20 de 33 c2 43 30 6e", subscription: "leds" },
    display: { width: 32, height: 8, indexMode: DataStructures_1.index_mode.TOP_LEFT, carriageReturnMode: DataStructures_1.carriage_return_mode.SNAKED, gpioPin: PIN, pixelType: Adafruit_NeoPixel_1.NEO_GRB + Adafruit_NeoPixel_1.NEO_KHZ800 }
};
const snakeLights = new snake_lights_1.SnakeLights(cfg);
const mqtt = new mqtt_connection_1.mqtt_connection(cfg);
const processor = new message_processor_1.message_processor(cfg, mqtt, snakeLights);
class Program {
    setup() {
        return __awaiter(this, void 0, void 0, function* () {
            ArduinoGlobals_1.Serial.begin(115200);
            ArduinoGlobals_1.delay(1000);
            yield snakeLights.init();
            snakeLights.set_status_pixel(255, 0, 0);
            ArduinoGlobals_1.Serial.println("Testing WiFi connection...");
            yield networking_1.networking.ensure_wifi_connected(cfg.wifi.ssid, cfg.wifi.password);
            snakeLights.set_status_pixel(53, 153, 0);
            ArduinoGlobals_1.Serial.println("Testing MQTT connection...");
            mqtt.ensure_mqtt_connected(this.process);
            ArduinoGlobals_1.Serial.println("Device is now ready.");
            snakeLights.set_status_pixel(0, 255, 0);
            yield ArduinoGlobals_1.delay(1000); // So we can *see* the green light! - not really needed in sim.
            snakeLights.clear();
        });
    }
    loop() {
        return __awaiter(this, void 0, void 0, function* () {
            // await snakeLights.testPattern();
            // await delay(2000);
            yield networking_1.networking.ensure_wifi_connected(cfg.wifi.ssid, cfg.wifi.password);
            mqtt.ensure_mqtt_connected(this.process);
            yield mqtt.process_messages();
            yield ArduinoGlobals_1.delay(interval);
        });
    }
    process(client, topic, payload, payload_length) {
        return __awaiter(this, void 0, void 0, function* () {
            yield processor.process(payload, payload_length);
        });
    }
}
exports.Program = Program;
//# sourceMappingURL=ArduinoProgram.js.map